import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useNavigate } from "react-router";
import Searching from "../components/Searching";
import NoDataFound from "../components/NoDataFound";
import { Link } from "react-router-dom";
import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const UpdatePassword = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Activation Code"
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const codeNumber = new URLSearchParams(window.location.search).get("code");
  const [loading, setLoading] = useState(true);
  const [dispalayMessage, setDisplayMessage] = useState("");
  const [isCheck, setIsCheck] = useState(1);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isChangePassword, setIsChangePassword] = useState(false);

  useEffect(() => {
    const verifyFn = async () => {
      setLoading(true);
      try {
        const userData = await postData("verify-hash", {
          hash_number: codeNumber,
        });
        if (userData.status && userData.status === 200) {
          setIsCheck(2);
          setLoading(false);
        } else {
          setLoading(false);
          setDisplayMessage(userData.message);
        }
      } catch (error) {
        setLoading(false);
        setDisplayMessage(error.message);
      }
    };
    verifyFn();
  }, [codeNumber]);

  const onChangePassword = async (e) => {
    e.preventDefault();
    setIsChangePassword(true);
    try {
      const userData = await postData("reset-password", {
        hash_number: codeNumber,
        password: password,
        confirm_password: confirmPassword,
      });
      if (userData.status && userData.status === 200) {
        setIsChangePassword(false);
        toastr.success(userData.message);
        return navigate("/signin");
      } else {
        toastr.error(userData.message);
        setIsChangePassword(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsChangePassword(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center">
      <div className="relative py-3 max-w-[288px] sm:max-w-md mx-auto w-full ">
        <div class="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-600 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
        <div class="relative px-4 py-10 bg-white shadow-lg rounded-3xl ">
          <Link to={"/"}>
            <div className="h-14 w-full flex justify-center object-contain mb-5">
              <Image
                src={MAIN_LOGO}
                alt={""}
                width={"100%"}
                height={"100%"}
                classes={"object-contain object-center"}
              />
            </div>
          </Link>
          <div className="max-w-64 sm:max-w-xs mx-auto ">
            {isCheck && isCheck === 1 ? (
              <div className="">
                {loading ? (
                  <Searching label={"Loading..."} />
                ) : (
                  <NoDataFound label={dispalayMessage} />
                )}
                <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                  {t("you_have_been_here_before")}
                  <Link to={"/signin"} className="text-teal-500 font-semibold">
                    {t("signin")}
                  </Link>
                  {t("now")}
                </div>
              </div>
            ) : (
              <>
                <div className="relative space-y-1 mb-5">
                  <h1 className="text-lg sm:text-2xl font-bold text-center text-slate-700">
                    {" "}
                    {t("update_password")}
                  </h1>
                  <div className="text-sm sm:text-base text-slate-900 text-center font-medium">
                    {t("please_use_your_credentials_to_update_password")}
                  </div>
                </div>
                <form class="space-y-2 sm:space-y-4 w-full">
                  <div className="relative z-0 w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"password"}
                      inputPlaceholder={t("new_password")}
                      inputValue={password}
                      setInput={setPassword}
                      //errorType={''}
                    />
                  </div>
                  <div className="relative z-0 w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"password"}
                      inputPlaceholder={t("confirm_password")}
                      inputValue={confirmPassword}
                      setInput={setConfirmPassword}
                      //errorType={''}
                    />
                  </div>
                  <div className="relative flex justify-center !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isChangePassword
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-floppy-disk"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("save_password")}
                      functions={onChangePassword}
                      buttonHasLink={false}
                      buttonDisabled={isChangePassword}
                    />
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdatePassword;
